const formatCourierNumber = numbersToFormat => {
  if (!numbersToFormat) {
    return '';
  }
  let phone = numbersToFormat;
  if (numbersToFormat?.[0] === '7' || numbersToFormat?.[0] === '8') {
    phone = phone.substring(1);
  }
  return `+7 (${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(
    6,
    8
  )}-${phone.slice(8, 10)}`;
};

export default formatCourierNumber;
